<template>
    <div class="buefy-menu" :class="showMenu ? 'buefy-menu-oppened' : 'buefy-menu-closed'">
        <div class="contexto">
            <b-dropdown aria-role="list" :mobile-modal="false">
                <button class="button contexto-button" slot="trigger" v-if="context">
                    <div class="contexto-label">
                        <svg class="svg-icons">
                            <use
                                :xlink:href="
                                    require('@/assets/img/contextos/' + context + '.svg') + '#layer'
                                "
                            />
                        </svg>
                        <span>{{ getT(context) }}</span>
                    </div>
                    <b-icon icon="menu-down" />
                </button>
                <template v-for="obj in app_modulo.data.app_moduloList">
                    <b-dropdown-item
                        v-if="obj.visivel && obj.permite"
                        aria-role="listitem"
                        :key="obj.nome"
                        @click="updateContexto(obj.nome)"
                    >
                        <div class="contexto-label">
                            <svg class="svg-icons">
                                <use
                                    :xlink:href="
                                        require('@/assets/img/contextos/' + obj.nome + '.svg') +
                                        '#layer'
                                    "
                                />
                            </svg>
                            <span>{{ getT(obj.nome) }}</span>
                        </div>
                    </b-dropdown-item>
                </template>
            </b-dropdown>
        </div>

        <div class="menu">
            <search-bar
                :onSearch="debouncedOnSearch"
                :clean="cleanOnChangeModule"
                hideTitle
            />
        </div>

        <!-- MENU DO CONTEXTO -->
        <ul class="menu-items">
            <div v-for="item in filteredItemsCockpit[context]" :key="item.nome">
                <router-link
                    v-if="!isNull(item.codigounicotela)"
                    :to="{ name: item.codigounicotela }"
                    class="menu-item"
                    tag="li"
                >
                    <svg class="svg-icons" v-if="!item.iconeexterno">
                        <use :xlink:href="buscaIcone(item.icone)" />
                    </svg>
                    <b-icon
                        v-else-if="item.iconeexterno"
                        class="menu-wrapper"
                        custom-class="menu-icon-sidebar"
                        :icon="item.icone"
                    />
                    <div :class="tagnew(item.tagnew)">{{ getT(item.nome) }}</div>
                </router-link>

                <li v-else class="menu-item" @click="menuItemHandler(item)">
                    <svg class="svg-icons" v-if="!item.iconeexterno">
                        <use :xlink:href="buscaIcone(item.icone)" />
                    </svg>
                    <b-icon
                        v-else-if="item.iconeexterno"
                        class="menu-wrapper"
                        custom-class="menu-icon-sidebar"
                        :icon="item.icone"
                    />
                    <div :class="tagnew(item.tagnew)">{{ getT(item.nome) }}</div>

                    <ul
                        v-if="item.app_tela && item.app_tela.length > 0"
                        class="submenu-items"
                        :class="{ 'show-submenu': item.expanded }"
                        @click.stop
                    >
                        <router-link
                            class="submenu-item"
                            v-for="sub in getItensPermitidos(item.app_tela)"
                            :key="sub.codigounicotela"
                            :to="{ name: sub.codigounicotela }"
                            @click.native="subItemHandler"
                        >
                            <li :class="tagnew(sub.tagnew)">
                                {{ getT(sub.nome) }}
                            </li>
                        </router-link>
                    </ul>
                </li>
            </div>

            <MenuColaborador
                v-if="!modulosPaiSemColaborador.includes(context)"
                :data="data"
                :busca="buscaColaborador"
                :key="sidebarKey"
            />

            <div v-for="item in filteredItemsNoCockpit[context]" :key="item.nome">
                <router-link
                    v-if="!isNull(item.codigounicotela)"
                    :to="{ name: item.codigounicotela }"
                    class="menu-item"
                    tag="li"
                >
                    <svg class="svg-icons" v-if="!item.iconeexterno">
                        <use :xlink:href="buscaIcone(item.icone)" />
                    </svg>
                    <b-icon
                        v-else-if="item.iconeexterno"
                        class="menu-wrapper"
                        custom-class="menu-icon-sidebar"
                        :icon="item.icone"
                    />
                    <div :class="tagnew(item.tagnew)">{{ getT(item.nome) }}</div>
                </router-link>

                <li v-else class="menu-item" @click="menuItemHandler(item)">
                    <svg class="svg-icons" v-if="!item.iconeexterno">
                        <use :xlink:href="buscaIcone(item.icone)" />
                    </svg>
                    <b-icon
                        v-else-if="item.iconeexterno"
                        class="menu-wrapper"
                        custom-class="menu-icon-sidebar"
                        :icon="item.icone"
                    />
                    <div :class="tagnew(item.tagnew)">{{ getT(item.nome) }}</div>

                    <ul
                        v-if="item.app_tela && item.app_tela.length > 0"
                        class="submenu-items"
                        :class="{ 'show-submenu': item.expanded }"
                        @click.stop
                    >
                        <router-link
                            class="submenu-item"
                            v-for="sub in getItensPermitidos(item.app_tela)"
                            :key="sub.codigounicotela"
                            :to="{ name: sub.codigounicotela }"
                            @click.native="subItemHandler"
                        >
                            <li :class="tagnew(sub.tagnew)">
                                {{ getT(sub.nome) }}
                            </li>
                        </router-link>
                    </ul>
                </li>
            </div>

            <MenuIntegracao
                v-if="!modulosPaiSemIntegracao.includes(context)"
                :data="data"
                :busca="buscaIntegracao"
            />
        </ul>

        <!-- COPYRIGHT -->
        <div class="bottom-menu" :class="{ 'bottom-menu-gambi': needGambi }">
            <p>
                © Sovis - {{ new Date() | moment('YYYY') }}
                <br />
                <b>v{{ $cookies.get('version') }} ({{ build_number }})</b>
                <router-link
                    class="licences"
                    tag="a"
                    key="sobre"
                    :to="{ name: 'licencas-comerciais' }"
                >
                    <div>{{ getT('sobre') }}</div>
                </router-link>
            </p>
        </div>
    </div>
</template>

<script>
import MenuConfig from '@/functions/Menu.js';
import MenuColaborador from '@/buefy/MenuColaborador.vue';
import MenuIntegracao from '@/buefy/MenuIntegracao.vue';
import { mapState } from 'vuex';

export default {
    name: 'Menu',
    components: {
        MenuColaborador,
        MenuIntegracao,
    },
    data() {
        return {
            sidebarItems: new MenuConfig(),
            items: [],
            filteredItems: [],
            filteredItemsCockpit: {},
            filteredItemsNoCockpit: {},
            needGambi: false,
            build_number: '7',
            modulos: [],
            modulosPaiSemColaborador: ['b2b', 'jupiter'],
            modulosPaiSemIntegracao: ['b2b', 'jupiter'],
            debouncedOnSearch: null,
            cleanOnChangeModule: false,
            data: null,
            buscaColaborador: '',
            buscaIntegracao: '',
            sidebarKey: 0,
            debounceResize: null,
        };
    },
    computed: {
        ...mapState(['context', 'showMenu', 'app_modulo']),
    },
    created() {
        this.data = this.$store.state.app_modulo.disponivel
            ? this.$store.state.app_modulo.data
            : null;

        this.items = this.sidebarItems.loadSidebar(
            this.$store.state.app_modulo.disponivel ? this.$store.state.app_modulo.data : null
        );
        this.filteredItems = JSON.parse(JSON.stringify(this.items));

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.onSearch('');

        if (this.$store.state.modulopda.disponivel && this.$store.state.modulopda.data) {
            this.modulos = this.$store.state.modulopda.data.map((e) =>
                e.descricao.toLocaleUpperCase()
            );
        }

        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    mounted() {
        setTimeout(() => {
            this.setActived();
        }, 1000);
    },
    methods: {
        handleResize() {
            clearTimeout(this.debounceResize);
            this.debounceResize = setTimeout(() => {
                if (this.showMenu && window.innerWidth <= 760) {
                    this.$store.dispatch('showMenu', { value: false });
                }
            }, 200);
        },
        onSearch(value) {
            this.buscaColaborador = value;
            this.buscaIntegracao = value;

            if (value && value.trim() != '') {
                // ALTERAR FILTERS, TENTAR USAR PUSH NUM ARRAY NOVO QUE PODE PERDER REFERENCIA
                this.filteredItems[this.context] = [];
                this.items[this.context].forEach((item) => {
                    let obj = JSON.parse(JSON.stringify(item));
                    let tempArrayOfItems = [];

                    if (item.app_tela != null) {
                        item.app_tela.forEach((tela) => {
                            let x = this.getT(tela.nome);
                            if (x != undefined) {
                                if (x.toLowerCase().includes(value.toLowerCase())) {
                                    tempArrayOfItems.push({ ...tela });
                                }
                            }
                        });
                    }

                    obj.app_tela = tempArrayOfItems;
                    if (tempArrayOfItems.length > 0) {
                        this.filteredItems[this.context].push(obj);
                    }
                });
            } else {
                if (this.items[this.context]) {
                    this.filteredItems[this.context] = JSON.parse(
                        JSON.stringify(this.items[this.context])
                    );
                }
            }
            this.updateMenu(value);
        },
        // Filtra os itens excluindo o cockpit, para mante-lo sempre em primeiro
        updateMenu(value) {
            for (let key in this.filteredItems) {
                this.filteredItemsNoCockpit[key] = this.filteredItems[key].filter((z) => {
                    if (z.nome != 'cockpit') {
                        if (value != '') {
                            z.expanded = true;
                        }
                        return z;
                    }
                });
                this.filteredItemsCockpit[key] = this.filteredItems[key].filter((y) => {
                    if (y.nome == 'cockpit') {
                        return y;
                    }
                });
            }
        },
        updateContexto(context) {
            if (context && context != this.context) {
                // Ao incrementar a chave do componente, vue vai redesenha-lo na tela

                this.sidebarKey += 1;
                let replaceBy = this.getTelaDefaultByContext(context);
                console.log(`Redirecionando para o context ${replaceBy}`);
                this.$router.push({ name: replaceBy });

                this.cleanOnChangeModule = true;
                this.onSearch('');
                setTimeout(() => {
                    this.cleanOnChangeModule = false;
                }, 300);
            }
        },
        menuItemHandler(item) {
            if (item.clickfn && typeof this[item.clickfn] === 'function') {
                /* A função tem que retornar true/false se permitir expandir o sub-item ou não */
                if (this[item.clickfn]()) {
                    item.expanded = !item.expanded;
                }
            } else {
                item.expanded = !item.expanded;
            }
        },
        getItensPermitidos(items) {
            /* Filtrar os itens que não tem permissão via MODULOPDA */

            return items.filter((sub) => {
                if (sub.admin === true) {
                    return this.$store.state.user.admin == sub.admin;
                }

                /* Se não houver especificação de moduloPDA, permitir aparecer. */
                if (sub.modulopda == undefined) {
                    return true;

                    /* Se houver, verificar */
                } else {
                    return (
                        this.moduloDisponivel(sub.modulopda) &&
                        this.moduloPermiteInlcuir(sub.modulopda)
                    );
                }
            });
        },
        subItemHandler() {
            /* $parent = Header.vue */
            if (this.$parent.bigScreen === false) {
                /* Se o sidebar estiver no modo mobile, vai esconder ao clicar em um item */
                this.$parent.showBar = false;
            }
        },
        promptGeo() {
            return true;
        },
        redirectConfigMapa() {
            this.$router.push({ name: 'configuracao-mapas' });
        },
        setActived() {
            let caminhoAtual = this.$route.path;

            if (this.items[this.context]) {
                this.items[this.context].forEach((item) => {
                    if (item.expanded != undefined && caminhoAtual.includes(item.nome)) {
                        item.expanded = true;
                    }
                });
            }
        },
        moduloDisponivel(descricao) {
            return this.modulos.includes(descricao.toLocaleUpperCase());
        },
        moduloPermiteInlcuir(descricao) {
            let canAppear = false;
            this.$store.state.modulopda.data.some((mod) => {
                if (mod.descricao == descricao.toLocaleUpperCase()) {
                    canAppear = mod.inclui == 1;
                    return canAppear;
                }
            });
            return canAppear;
        },
        buscaIcone(icone) {
            try {
                return require(`@/assets/img/icons/${icone}.svg`) + '#layer';
            } catch (error) {
                console.error(`O seguinte ícone não foi encontrado: ${error}`);
                return require('@/assets/img/icons/alert-circle.svg') + '#layer';
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@mixin hiddenSubMenu($percent) {
    opacity: 0 !important;
    margin-bottom: $percent !important;
}

@mixin transitionSubMenu($duration) {
    transition: opacity $duration, margin $duration;
    transition-timing-function: ease-in;
}

.buefy-menu-oppened {
    width: 250px;
}

.buefy-menu-closed {
    width: 0px;
}

.buefy-menu {
    flex-shrink: 0;
    background-color: $sovis-white;
    color: $light-gray-color;
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    border-top-right-radius: 5px;
    box-shadow: 0px 0px 3px rgba(56, 56, 56, 0.2);
    // transition: left 0.1s, width 0.5s;

    ul {
        list-style: none;
    }

    .bottom-menu {
        width: 100%;
        height: auto;
        flex: 0 0 auto;
    }

    .bottom-menu .menu-item-detached {
        padding-left: 40px;
        padding-bottom: 10px;
        > a {
            color: $darker-gray-color;
            font-weight: 600;
            font-size: 14px;
            margin-top: 10px;
            text-decoration: none;
        }
        &:nth-child(2) {
            border-top: 1px solid $table-border;
            border-bottom: 1px solid $table-border;
        }
    }
    .bottom-menu p {
        text-align: center;
        //  padding-left: 60px;
        font-size: 14px;
        margin-top: 15px;
        margin-bottom: 15px;
        color: $light-gray-color;
    }
    .menu-items {
        padding: 0;
        flex: 1 1 auto;
    }
    .menu-item {
        position: relative;
        cursor: pointer;
        transition: color 0.2s;
        background: $sovis-white;
        padding: 0 0 9px 40px;
        display: flex;
        flex-wrap: wrap;

        > .svg-icons,
        > .menu-wrapper {
            fill: $darker-gray-color;
            width: 14px;
            height: 14px;
            margin-left: -9px;
            margin-right: 11px;
            margin-top: 14px;
        }

        > .menu-wrapper {
            width: 12px;
            height: 12px;
        }

        > span {
            margin-left: -10px;
            margin-right: 15px;
        }

        > div {
            color: $darker-gray-color;
            font-size: 14px;
            text-decoration: none;
            font-weight: 600;
            margin-top: 11px;
        }

        &:hover {
            background-color: $bg-color;
        }

        &:hover .svg-icons {
            fill: $primary-color;
            background-color: $bg-color;
        }
        &:hover .menu-wrapper {
            color: $primary-color;
            background-color: $bg-color;
        }

        &:before {
            width: 35px;
        }

        &.active,
        &.active .svg-icons {
            background-color: $bg-color;
            fill: $primary-color;
        }

        &.active .menu-wrapper {
            color: $primary-color;
            background-color: $bg-color;
        }

        .block-menu {
            width: 100%;
            height: 100%;
        }
    }

    .menu-item.active::before,
    .menu-item:hover::before {
        content: '|';
        border-left: 5px solid $primary-color;
        margin-left: -40px;
        margin-right: 35px;
        font-size: 26px;
        line-height: 44px;
        color: $bg-color;
        position: absolute;
    }

    .menu {
        width: 100%;
        text-align: center;
        font-weight: 600;
        padding: 26px 5px 16px 5px;
        font-size: 12px;
    }

    .submenu-items {
        left: -40px;
        position: relative;
        top: 10px;
        width: 100%;
        background: $sovis-white;
        flex: 0 0 100%;
        padding-left: 40px;
        box-sizing: content-box;
        overflow: hidden;
        opacity: 0;
        max-height: 0;
        transition: max-height 0.5s, opacity 1s;
    }

    .show-submenu {
        opacity: 1;
        max-height: 2000px;
    }

    .submenu-item {
        li {
            position: relative;
            font-size: 12px;
            margin-bottom: 5px;
            transition: color 0.2s;
            padding: 10px 5px 10px 0;
            z-index: 5;
            margin-left: 25px;
            cursor: pointer;
            color: $darker-gray-color;
            text-decoration: none;
            font-weight: 600;
        }

        > span {
            margin-left: -10px;
            margin-right: 15px;
        }

        &:hover {
            color: $primary-color;
            list-style-type: disc;
        }

        &:before {
            width: 35px;
        }

        &.active {
            list-style-type: disc;
            color: $primary-color;
        }

        .block-menu {
            width: 100%;
            height: 100%;
        }

        &:first-child {
            margin-top: 10px;
        }
    }

    .licences {
        text-decoration: none;
        color: $light-gray-color;
    }

    .pro-enter-active,
    .pro-leave-active,
    .geo-enter-active,
    .geo-leave-active,
    .produto-enter-active,
    .produto-leave-active,
    .bs-data-enter-active,
    .bs-data-leave-active,
    .colaborador-enter-active,
    .colaborador-leave-active,
    .reports-enter-active,
    .reports-leave-active {
        @include transitionSubMenu(0.5s);
    }

    .pro-enter,
    .pro-leave-to,
    .geo-enter,
    .geo-leave-to,
    .produto-enter,
    .produto-leave-to,
    .bs-data-enter,
    .bs-data-leave-to,
    .colaborador-enter,
    .colaborador-leave-to,
    .reports-enter,
    .reports-leave-to {
        @include hiddenSubMenu(-245px);
    }

    .contexto-button {
        width: 100%;
        background: $primary-color;
        color: $sovis-white;
        border: 0;
        border-radius: 0 5px 0 0;
        padding-top: 7px;
        justify-content: space-between;

        &:hover,
        &:focus {
            border: 0;
            color: $sovis-white;

            &:not(:active) {
                box-shadow: none;
            }
        }
    }

    .v-select .dropdown-toggle {
        .selected-tag {
            text-transform: uppercase;
        }
        .clear {
            display: none;
        }
    }

    &::-webkit-scrollbar {
        width: 7px;
        height: 7px;
    }

    &::-webkit-scrollbar-track {
        background: $darker-bg-color;
        border-radius: 1rem;
    }

    &::-webkit-scrollbar-thumb {
        background: $sb-background;
        border-radius: 1rem;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: $light-gray-color;
    }
}

@media only screen and (max-width: 760px) {
    .buefy-menu {
        z-index: 1000;
        position: fixed;
        top: 50px;
        bottom: 0;
    }
    .contexto-button {
        border-radius: 0;
    }
}

@media only screen and (max-height: 850px) {
    .bottom-menu {
        width: 100%;
        height: 80px;
    }
}
</style>
